import apiClient from './api';

export type ServiceProviderDepositPaymentStatus = 'pending' | 'paid' | 'failed';

export interface ServiceProviderDepositPaymentListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  status?: ServiceProviderDepositPaymentStatus | 'all';
  startDate?: string;
  endDate?: string;
}

export interface ServiceProviderDepositPaymentItem {
  id: string;
  paymentNo: string;
  providerId: string;
  providerName: string;
  providerPhone: string;
  amount: number;
  amountText: string;
  status: ServiceProviderDepositPaymentStatus | string;
  statusText: string;
  payChannel: string;
  prepayId: string;
  tradeNo: string;
  payerOpenId: string;
  notifyUrl: string;
  remark: string;
  paidAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceProviderDepositPaymentListResponse {
  list: ServiceProviderDepositPaymentItem[];
  total: number;
  page: number;
  pageSize: number;
}

export const listServiceProviderDepositPayments = async (
  params?: ServiceProviderDepositPaymentListParams,
): Promise<ServiceProviderDepositPaymentListResponse> => {
  const response = await apiClient.get<ServiceProviderDepositPaymentListResponse>(
    '/service-provider-deposit-payments',
    { params },
  );
  return response.data;
};
